import { getPaymentMethodGroup, isEmptyOrNil } from 'core/helpers';

export const ALL_METHODS_KEY = 'All Methods';

export const createPaymentMethodGroupMap = ({ plainItems }) => {
  const groupMap = {};

  if (isEmptyOrNil(plainItems)) {
    return groupMap;
  }

  groupMap[ALL_METHODS_KEY] = [];
  plainItems.forEach((plainItem) => {
    const group = getPaymentMethodGroup(plainItem.code);

    if (group) {
      if (!groupMap[group]) {
        groupMap[group] = [plainItem];
      } else {
        groupMap[group].push(plainItem);
      }
    }

    groupMap[ALL_METHODS_KEY].push(plainItem);
  });

  return groupMap;
};

const filterByGroup = ({ group, groupMap, plainItems }) => {
  const groupElements = groupMap[group];

  return plainItems.filter(item => groupElements.find(el => el.code === item.code));
};

export const filterByPaymentMethodGroup = ({
  recentlyItems,
  otherItems,
  group,
  groupMap,
}) => {
  let other = [];
  let recently = [];

  if (!isEmptyOrNil(recentlyItems)) {
    recently = filterByGroup({ group, groupMap, plainItems: recentlyItems });
  }

  if (!isEmptyOrNil(otherItems)) {
    other = filterByGroup({ group, groupMap, plainItems: otherItems });
  }

  return {
    recently,
    other
  };
};
